export const participantConstant = {
    withAcs: "Data Hosted With ACS",
    online: "Online Interface"
};

export const otpGeneratorConstant = {
    acs: "Managed By Paysys",
    bank: "Managed By Bank",
}

export const transactionStatusConstant = {
    pass: "PASS",
    fail: "FAIL",
    pending: 'PENDING',
};

export const transactionReqStatusConstant = {
    success: "SUCCESS",
    failed: "FAILED",
    pending: 'PENDING',
};

export const transactionTypeConstant = {
    Challenge: "CHALLENGE",
    Frictionless: "FRICTIONLESS",
};

export const responseStatusConstant = {
    success: "SUCCESS",
    error: "ERROR",
    pending: 'PENDING',
};

export const actionTypeConstant = {
    view: "VIEW",
    add: "ADD",
    update: 'UPDATE',
};

export const ruleEngineConstant = {
    isNotConfigured: 0,
    pendingConfiguration: 1,
    isConfigured: 2,
};

export const dashboardTabsConstant = {
    today: 'today',
    monthToDate: 'monthToDate',
    yearToDate: 'yearToDate',
};

export const createMccTabsConstant = {
    all: 'all',
    selected: 'selected',
};

export const createCountryCodeTabsConstant = {
    all: 'all',
    selected: 'selected',
};

export const fieldTypesConstant = {
    dropdown: 'dropdown',
    text: 'text',
};

export const CardStatusTabConstant = {
    profile: 'profile',
    controls: 'controls',
    history: 'history',
};

export const AuthHistoryTabConstant = {
    transactionLogs: 'transactionLogs',
    mPayLogs: 'mPayLogs',
    auditLogs: 'auditLogs',
    riskScoringLogs: 'riskScoringLogs',
};

export const templateConstant = {
    sms: `Your OTP code is {OTP}. Do not share this code with anyone. It is valid for {X}.`,
    email: `Dear User,\r\n\r\nYour One-Time Password (OTP) is {OTP}.\r\n\r\nThis OTP is valid for {X}. Please do not share it with anyone.\r\n\r\nIf you did not request this OTP, please ignore this email or contact our support team immediately.\r\n\r\nBest Regards,\r\n{InstitutionName} Support Team`,
};

export const participantOptions = [
    { value: participantConstant.withAcs, label: "Data Hosted with ACS" },
    { value: participantConstant.online, label: "Online Interface" },
];

export const otpGeneratorOptions = [
    { value: otpGeneratorConstant.acs, label: "Managed By Paysys" },
    { value: otpGeneratorConstant.bank, label: "Managed By Bank" },
];

export const transactionStatusOptions = [
    { value: transactionStatusConstant.pass, label: "Pass" },
    { value: transactionStatusConstant.fail, label: "Fail" },
    { value: transactionStatusConstant.pending, label: "Pending" },
];

export const transactionReqStatusOptions = [
    { value: transactionReqStatusConstant.success, label: "Success" },
    { value: transactionReqStatusConstant.failed, label: "Failed" },
    { value: transactionReqStatusConstant.pending, label: "Pending" },
];

export const transactionTypeOptions = [
    { value: transactionTypeConstant.Challenge, label: "Challenge" },
    { value: transactionTypeConstant.Frictionless, label: "Frictionless" },
];

export const responseStatusOptions = [
    { value: responseStatusConstant.success, label: "Success" },
    { value: responseStatusConstant.error, label: "Error" },
    { value: responseStatusConstant.pending, label: "Pending" },
];

export const ruleEngineStatusOptions = [
    { value: ruleEngineConstant.isNotConfigured, label: "Not Configured" },
    { value: ruleEngineConstant.pendingConfiguration, label: "Pending Configuration" },
    { value: ruleEngineConstant.isConfigured, label: "Configured" },
];

export const dashboardTabsOptions = [
    { value: dashboardTabsConstant.today, label: "Today" },
    // { value: dashboardTabsConstant.monthToDate, label: "Month to Date" },
    // { value: dashboardTabsConstant.yearToDate, label: "Year to Date" },
];

export const createMccTabsOptions = [
    { value: createMccTabsConstant.all, label: "All" },
    { value: createMccTabsConstant.selected, label: "Selected" },
];

export const createCountryCodeTabsOptions = [
    { value: createCountryCodeTabsConstant.all, label: "All" },
    { value: createCountryCodeTabsConstant.selected, label: "Selected" },
];

export const fieldTypesOptions = [
    { value: fieldTypesConstant.dropdown, label: "Dropdown" },
    { value: fieldTypesConstant.text, label: "Text" },
];